/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Export_Free_TextInputs */



/**
* | output |
* | --- |
* | "The Free plan exports SRT, VTT and TXT files. Upgrade to Starter or Pro for this export." |
*
* @param {Upgrade_Export_Free_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const upgrade_export_free_text = /** @type {((inputs?: Upgrade_Export_Free_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Export_Free_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le forfait Free exporte les fichiers SRT, VTT et TXT. Passez à Starter ou Pro pour cette exportation.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit dem Free-Tarif können Sie SRT-, VTT- und TXT-Dateien exportieren. Für diesen Export benötigen Sie Starter oder Pro.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il piano Free esporta file SRT, VTT e TXT. Passa a Starter o Pro per questa esportazione.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Тариф Free экспортирует файлы SRT, VTT и TXT. Для этого экспорта перейдите на Starter или Pro.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El plan Free exporta archivos SRT, VTT y TXT. Actualice a Starter o Pro para esta exportación.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Free 计划可导出 SRT、VTT 和 TXT 文件。如需此导出，请升级到 Starter 或 Pro。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Free プランでは SRT、VTT、TXT ファイルをエクスポートできます。このエクスポートには Starter または Pro へのアップグレードが必要です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Free प्लान SRT, VTT और TXT फ़ाइलें एक्सपोर्ट करता है। इस एक्सपोर्ट के लिए Starter या Pro में अपग्रेड करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O plano Free exporta ficheiros SRT, VTT e TXT. Atualize para Starter ou Pro para esta exportação.")
	return /** @type {LocalizedString} */ ("The Free plan exports SRT, VTT and TXT files. Upgrade to Starter or Pro for this export.")
});